import React from "react"

import {InternalLinkOption} from "../option"
import {lexicalChangeHeading} from "../../../actions/change-heading"
import {LexicalEditor} from "lexical"
import {lexicalChangeBlock} from "../../../actions/change-block"
import {PopoverMenuItemType} from "../../../../popover-menu/popover-menu/const"
import {BannerType} from "../../banner/banner-plugin"
import {getBannerStyles} from "../../banner/node/banner-node"
import {lexicalChangeBanner} from "../../../actions/change-banner"
import slashMenu_iconComponent from "./slah-menu-icon-component"

export default function editor_headingOptions(editor: LexicalEditor, blockType: any) {

    const bannerIconComponent = (bannerType: BannerType) =>
        <div className="flex-row-center-center bg-palette-gray-5 border-radius-4 w-24 h-24 m-r-8">
            <div className="editor-i5-banner fs-16" style={_.pick(getBannerStyles(bannerType), 'color')}/>
        </div>

    const bannerOptions = _.map([
        {value: BannerType.LIGHT_BLUE,  iconComponent: bannerIconComponent(BannerType.LIGHT_BLUE),    label: 'Light blue'},
        {value: BannerType.DARK_BLUE,   iconComponent: bannerIconComponent(BannerType.DARK_BLUE),     label: 'Dark blue'},
        {value: BannerType.GREEN,       iconComponent: bannerIconComponent(BannerType.GREEN),         label: 'Green'},
        {value: BannerType.YELLOW,      iconComponent: bannerIconComponent(BannerType.YELLOW),        label: 'Yellow'},
        {value: BannerType.ORANGE,      iconComponent: bannerIconComponent(BannerType.ORANGE),        label: 'Orange'},
        {value: BannerType.RED,         iconComponent: bannerIconComponent(BannerType.RED),           label: 'Red'},
        {value: BannerType.MAGENTA,     iconComponent: bannerIconComponent(BannerType.MAGENTA),       label: 'Magenta'},
        {value: BannerType.PURPLE,      iconComponent: bannerIconComponent(BannerType.PURPLE),        label: 'Purple'},
        {value: BannerType.BROWN,       iconComponent: bannerIconComponent(BannerType.BROWN),         label: 'Brown'},
        {value: BannerType.GRAY,        iconComponent: bannerIconComponent(BannerType.GRAY),          label: 'Gray'},
    ], option =>
        new InternalLinkOption(option.label, {
            iconComponent: option.iconComponent,
            action  : () => {
                lexicalChangeBanner(editor, blockType, option.value)
            }
        })
    )

    const normal = new InternalLinkOption('Normal', {
        id              : 'normal',
        // icon            : 'editor-i5-normal-text fs-16',
        iconComponent   : slashMenu_iconComponent('editor-i5-normal-text'),
        keywords        : ['paragraph', 'normal'],
        action          : () => {
            lexicalChangeHeading(editor, 'custom-paragraph')
        }
    })

    const heading1 = new InternalLinkOption('Heading 1', {
        id              : 'heading1',
        // icon            : 'editor-i5-heading-1 fs-16',
        iconComponent   : slashMenu_iconComponent('editor-i5-heading-1'),
        keywords        : ['h1', 'heading 1'],
        action          : () => {
            lexicalChangeHeading(editor, 'h1')
        }
    })

    const heading2 = new InternalLinkOption('Heading 2', {
        id              : 'heading2',
        // icon            : 'editor-i5-heading-2 fs-16',
        iconComponent   : slashMenu_iconComponent('editor-i5-heading-2'),
        keywords        : ['h2', 'heading 2'],
        action          : () => {
            lexicalChangeHeading(editor, 'h2')
        }
    })

    const heading3 = new InternalLinkOption('Heading 3', {
        id              : 'heading3',
        // icon            : 'editor-i5-heading-3 fs-16',
        iconComponent   : slashMenu_iconComponent('editor-i5-heading-3'),
        keywords        : ['h3', 'heading 3'],
        action          : () => {
            lexicalChangeHeading(editor, 'h3')
        }
    })

    const banner = new InternalLinkOption('Banner', {
        id              : 'banner',
        type            : PopoverMenuItemType.SUBMENU,
        // icon            : 'editor-i5-banner fs-16',
        iconComponent   : slashMenu_iconComponent('editor-i5-banner'),
        keywords        : ['banner'],
        options         : bannerOptions,
    })

    const codeBlock = new InternalLinkOption('Block code', {
        id              : 'codeBlock',
        // icon            : 'editor-i5-code fs-16',
        iconComponent   : slashMenu_iconComponent('editor-i5-code'),
        keywords        : ['code'],
        action          : () => {
            lexicalChangeBlock(editor, blockType, 'code')
        }
    })

    const quoteBlock = new InternalLinkOption('Block quote', {
        id              : 'quoteBlock',
        // icon            : 'editor-i5-quote fs-16',
        iconComponent   : slashMenu_iconComponent('editor-i5-quote'),
        keywords        : ['quote'],
        action          : () => {
            lexicalChangeBlock(editor, blockType, 'quote')
        }
    })

    const options = [
        normal,
        heading1,
        heading2,
        heading3,
        banner,
        codeBlock,
        quoteBlock
    ]

    let optionsBlockKeywords: string[] = []
    _.map(options, option=>optionsBlockKeywords = optionsBlockKeywords.concat(option.keywords))

    return [
        new InternalLinkOption('Text style', {
            type        : PopoverMenuItemType.HEADER,
            keywords    : optionsBlockKeywords
        }),

        ...options,

        new InternalLinkOption('', {
            type        : PopoverMenuItemType.SEPARATOR,
            keywords    : optionsBlockKeywords
        }),
    ]
}